import React from 'react';
import { useTranslation } from 'react-i18next';

import Header from '../../components/shared/Header/Header';

import AccountTabs from './AccountTabs/AccountTabs';

const Account = ({ tab, subTab }) => {
  const { t } = useTranslation('common');
  return (
    <div className="h-[100vh] overflow-y-hidden max-md:h-[calc(100vh-50px)]">
      <Header title={t('headers.myAccount')} />
      <AccountTabs tab={tab} subTab={subTab} />
    </div>
  );
};

export default Account;
